import { configureStore } from "@reduxjs/toolkit";

// masters reducer
import masters from "./masters";

import settings from "../features/settings/Slice";

//faqs reducer
import faqs from "./faqs";

//blogs reducer
import blogs from "./blogs";

//services
import services from "./services";

//Aboutus
import aboutus from "./aboutus";

//Customizations
import customizations from "./customizations";

//Subsidy policys
import subsidypolicys from "./subsidypolicys";

//Privacy policys
import privacypolicys from "./privacypolicys";

//terms of services
import termsofservices from "./termsofservices";

//home page
import homepage from "./homepage";

//gallerys
import gallerys from "./gallerys";

//dashboard
import dashboard from "./dashboard";

//contactuss
import contactuss from "./contactuss";

//freeconsultations
import freeconsultations from "./freeconsultations";

export const store = configureStore({
  reducer: {
    masters,
    faqs,
    blogs,
    services,
    aboutus,
    customizations,
    subsidypolicys,
    privacypolicys,
    termsofservices,
    homepage,
    gallerys,
    dashboard,
    contactuss,
    freeconsultations,
    settings,
  },
});
